export const USER_QRCODE_DATA = 'USER_QRCODE_DATA';
export const USER_SELECTED_SCANNER_ACTION = 'USER_SELECTED_SCANNER_ACTION';
export const USER_SELECTED_CAMERA_ID = 'USER_SELECTED_CAMERA_ID';
export const USER_COMPLETABLE_TODO_TASKS = 'USER_COMPLETABLE_TODO_TASKS_NEW';
export const DASHBOARD_LAYOUT_IS_COLLAPSED = 'DASHBOARD_LAYOUT_IS_COLLAPSED';
export const COUNTER_MONITORING_SIDEBAR_IS_COLLAPSED =
  'COUNTER_MONITORING_SIDEBAR_IS_COLLAPSED';
export const COUNTER_MONITORING_LAST_ASSET_ID =
  'COUNTER_MONITORING_LAST_ASSET_ID';
export const COUNTER_MONITORING_LAST_COUNTER_IDS =
  'COUNTER_MONITORING_LAST_COUNTER_IDS';
export const FILE_PREVIEW_MODAL_MODE = 'FILE_PREVIEW_MODAL_MODE';
export const TASK_FILTER_FORM = 'TASK_FILTER_FORM';
export const DASHBOARD_OVERVIEW_FILTER_FORM = 'DASHBOARD_OVERVIEW_FILTER_FORM';
export const DASHBOARD_TIMELINE_FILTER_FORM = 'DASHBOARD_TIMELINE_FILTER_FORM';
export const DASHBOARD_MONITORING_FILTER_FORM =
  'DASHBOARD_MONITORING_FILTER_FORM';
export const DASHBOARD_MONITORING_FILTER_TYPE =
  'DASHBOARD_MONITORING_FILTER_TYPE';
export const GENERATE_REPORT_FORM = 'GENERATE_REPORT_FORM';
export const INTERVENTION_FILTER_FORM = 'INTERVENTION_FILTER_FORM';
export const SITE_LIST_FILTER_FORM = 'SITE_LIST_FILTER_FORM';
export const SITE_LIST_VIEW = 'SITE_LIST_VIEW';
export const SITE_MAP_VIEW_PARAMS = 'SITE_MAP_VIEW_PARAMS';
export const SITE_MONITORING_MAP_VIEW_PARAMS =
  'SITE_MONITORING_MAP_VIEW_PARAMS';
export const SECTOR_MONITORING_MAP_VIEW_PARAMS =
  'SECTOR_MONITORING_MAP_VIEW_PARAMS';
export const UPGRADE_PLAN_BANNER = 'UPGRADE_PLAN_BANNER';
export const TECHNICAL_PAUSE_BANNER = 'TECHNICAL_PAUSE_BANNER';
export const JOB_TRACKER_POSITION = 'JOB_TRACKER_POSITION';
export const JOB_TRACKER_OPENED = 'JOB_TRACKER_OPENED';
export const JOB_IDS = 'JOB_IDS';
export const JOB_DOWNLOADED_IDS = 'JOB_DOWNLOADED_IDS';
export const IMPORT_HISTORY_FORM = 'IMPORT_HISTORY_FORM';
export const IMPORT_FILTER_FORM = 'IMPORT_FILTER_FORM';
export const ANIMATION_LOADER_AVAILABLE = 'ANIMATION_LOADER_AVAILABLE';
export const LOCALES_DEBUG = 'LOCALES_DEBUG';
export const TASK_REPORTING_FILTER_FORM = 'TASK_REPORTING_FILTER_FORM';
export const SITES_MAP_WIDGET_VIEW_PARAMS = 'SITES_MAP_WIDGET_VIEW_PARAMS';
